import { Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { Notificacao } from '../../../interfaces/notificacao';
import { notificacaoVisual, NotificacaoVisual, montarNotificacao, textoSimples } from '../../../utils/notificacao-render';

export interface NotificacaoAvisoData {
  notificacao: Notificacao;
  /** Quantas outras novas ainda esperam na fila. */
  restantes: number;
}

/** Resultado do aviso: abriu a notificação ou dispensou. */
export type NotificacaoAvisoAcao = 'ver' | 'dispensar';

/**
 * Aviso de chegada de notificação nova — o equivalente web do balão do desktop.
 * Aparece uma vez por notificação (controle em notificacao-vistas).
 */
@Component({
  selector: 'app-notificacao-aviso',
  templateUrl: './notificacao-aviso.component.html',
  styleUrls: ['./notificacao-aviso.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class NotificacaoAvisoComponent {

  visual: NotificacaoVisual;
  resumo: string;
  capaUrl: string;

  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: NotificacaoAvisoData,
    private snackRef: MatSnackBarRef<NotificacaoAvisoComponent>
  ) {
    const n = data.notificacao;
    this.visual = notificacaoVisual(n?.tipoNotificacao);
    this.resumo = textoSimples(n?.texto);
    this.capaUrl = montarNotificacao(n).capaUrl;
  }

  ver() {
    this.snackRef.dismissWithAction();
  }

  dispensar() {
    this.snackRef.dismiss();
  }
}
